import { useMediaQuery } from "@mui/material";
import Image from "next/image";
import React, { RefObject, useState } from "react";

import { RestaurantItemType } from "../../../../../api/types/restaurant.type";
import { useMap } from "../../../../../store/map.context";
import imageLoader from "../../../../../utils/loader";
import MapInfoItem from "./Item";
import classes from "./mapMarker.module.scss";

interface Props {
  restaurantObject: RestaurantItemType;
  lat: number | undefined;
  lng: number | undefined;
  setModalIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  setMenuSelectionIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  inputRef?: RefObject<HTMLInputElement>;
}

const MapMarker = ({
  restaurantObject,
  setModalIsOpen,
  setMenuSelectionIsOpen,
  inputRef,
}: Props) => {
  const isMobile = useMediaQuery("(max-width: 1280px)");
  const { map, setMap } = useMap();
  const [open, setIsOpen] = useState(true);

  const getName = (value: string) => {
    return value.substring(10);
  };

  const onClickHandler = () => {
    if (inputRef)
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      inputRef.current!.value =
        restaurantObject.addresse + " " + getName(restaurantObject.name);
  };

  return (
    <div
      className={classes.container}
      onClick={() => {
        setMap((prevState) => ({
          ...prevState,
          id: restaurantObject.id,
          lat: restaurantObject.latitude as number,
          lng: restaurantObject.longitude as number,
        }));
      }}
      onBlur={() => setIsOpen(false)}
    >
      <Image
        loader={imageLoader}
        width={isMobile ? "30px" : "50px"}
        height={isMobile ? "30px" : "50px"}
        src={
          map.id === restaurantObject.id && open
            ? "location-pin1.png"
            : "location-pin2.png"
        }
        alt="map marker logo"
        onClick={() => onClickHandler()}
      />
      {map.id === restaurantObject.id && open && (
        <div className={classes.infoContainer} onBlur={() => setIsOpen(false)}>
          <MapInfoItem
            name={restaurantObject.name}
            ID={restaurantObject.id}
            location={restaurantObject.addresse}
            phone_number={restaurantObject.phone_number}
            opening_hours={restaurantObject.opening_hours}
            closing_rules={restaurantObject.closing_rules}
            setIsOpen={setIsOpen}
            setModalIsOpen={setModalIsOpen}
            setMenuSelectionIsOpen={setMenuSelectionIsOpen}
          />
        </div>
      )}
    </div>
  );
};

export default MapMarker;
